export default __webpack_public_path__ + "static/scyxy_hover-848cbb5cec931fe1ae2e1a7c57a7d4f3.png";